// canvas_renderer - S47.3b.
// Funciones de dibujo sobre HTMLCanvas 2D para QR (matriz NxN) y Code 128B
// (secuencia de barras 0/1). Tambien expone helper de texto con auto-shrink.
//
// Sin libs. Disenado para ser invocado desde png_export.js, pdf_export.js
// y FieldRenderer.jsx (preview en vivo).
import { encodeQrV4L } from './qr_encoder';
import { encodeCode128B } from './code128';

// Quiet zone QR estandar = 4 modulos blancos a cada lado.
const QR_QUIET = 4;

export function drawQrOnCanvas(ctx, value, x, y, w, h) {
  if (!ctx || !w || !h) return;
  const { matrix, size } = encodeQrV4L(value);
  // Fondo blanco
  ctx.fillStyle = '#fff';
  ctx.fillRect(x, y, w, h);
  // Calcular escala incluyendo quiet zone
  const totalCells = size + QR_QUIET * 2;
  const cell = Math.max(1, Math.floor(Math.min(w, h) / totalCells));
  const drawSize = cell * totalCells;
  // Centrar
  const ox = x + Math.floor((w - drawSize) / 2);
  const oy = y + Math.floor((h - drawSize) / 2);
  ctx.fillStyle = '#000';
  for (let r = 0; r < size; r += 1) {
    for (let c = 0; c < size; c += 1) {
      if (matrix[r][c]) {
        ctx.fillRect(
          ox + (c + QR_QUIET) * cell,
          oy + (r + QR_QUIET) * cell,
          cell,
          cell,
        );
      }
    }
  }
}

export function drawCode128OnCanvas(ctx, value, x, y, w, h) {
  if (!ctx || !w || !h) return;
  const { bars, value: filtered } = encodeCode128B(value);
  // Fondo blanco
  ctx.fillStyle = '#fff';
  ctx.fillRect(x, y, w, h);
  if (bars.length === 0) return;
  // Reservar 12 px abajo para label si h lo permite
  const labelPx = (h >= 24) ? 14 : 0;
  const barAreaH = h - labelPx;
  // Quiet zone: 10 modulos blancos a cada lado (estandar Code 128).
  const totalMods = bars.length + 20;
  const modWidth = Math.max(1, Math.floor(w / totalMods));
  const drawWidth = modWidth * totalMods;
  const ox = x + Math.floor((w - drawWidth) / 2);
  ctx.fillStyle = '#000';
  // Saltar quiet zone.
  let cursor = ox + 10 * modWidth;
  for (let i = 0; i < bars.length; i += 1) {
    if (bars[i]) {
      ctx.fillRect(cursor, y, modWidth, barAreaH);
    }
    cursor += modWidth;
  }
  if (labelPx > 0 && filtered) {
    drawTextAutoFit(ctx, filtered, x, y + barAreaH, w, labelPx, {
      mono: true, bold: true, color: '#000',
    });
  }
}

// Dibujo de texto con auto-shrink para caber en w. Reduce font-size hasta
// que measureText(value).width <= w - 4 o hasta llegar a 6 px.
export function drawTextAutoFit(ctx, value, x, y, w, h, opts) {
  const o = opts || {};
  const family = o.mono ? 'monospace' : 'sans-serif';
  const weight = o.bold ? '700' : '500';
  let fontPx = Math.max(8, Math.min(h * 0.7, w * 0.5));
  ctx.fillStyle = o.color || '#000';
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'center';
  ctx.font = weight + ' ' + Math.round(fontPx) + 'px ' + family;
  while (fontPx > 6 && ctx.measureText(String(value)).width > w - 4) {
    fontPx -= 1;
    ctx.font = weight + ' ' + Math.round(fontPx) + 'px ' + family;
  }
  ctx.fillText(String(value), x + w / 2, y + h / 2);
}
